import React from 'react'
import PropTypes from 'prop-types'

function BrowserLinks({ item, mini, children }) {
  const Gspc = item.species_abbrev

  const gspc = Gspc ? Gspc.toLowerCase() : 'dmel'
  // branch here on if(Gspc); if it exists, build url, if not disable buttons
//  const gbrowseurlroot = '/cgi-bin/gbrowse2/' + gspc + '/?Search=1;name='
//  const gbrowsetitle = mini ? 'GB' : 'GBrowse'
  const jbrowseurlroot = '/jbrowse/?data=data/json/' + gspc + '&loc='
  const jbrowsetitle = mini ? 'JB' : 'JBrowse'

  const dsblJB =
    gspc === 'dmel'
      ? ''
      : 'disabled' /* enhance this once other species are included */

  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      <a
        className={'btn btn-xs btn-success ' + dsblJB}
        href={jbrowseurlroot + item.id}>
        {jbrowsetitle}
      </a>
    </span>
  )
}

BrowserLinks.propTypes = {
  children: PropTypes.object,
  item: PropTypes.object.isRequired,
}

export default BrowserLinks
